import {Component} from '@angular/core';
import {PwaInstallService} from '../../services/pwa-install.service';

@Component({
    selector: 'app-pwa-install-banner',
    templateUrl: './pwa-install-banner.component.html',
    styleUrl: './pwa-install-banner.component.scss'
})
export class PwaInstallBannerComponent {
    constructor(public pwaInstallService: PwaInstallService) {
    }

    install() {
        this.pwaInstallService.promptInstall();
    }

    dismiss() {
        this.pwaInstallService.dismiss();
    }
}
